import Marquee from "react-fast-marquee";

const items = [
  "AI Chat",
  "Quiz Generator",
  "Flashcards",
  "Smart Notes",
  "Homework Help",
  "Script Generation",
  "Hook Generation",
  "Image Generation",
  "Thumbnail Analyzer",
  "Video Analysis",
  "Document Generator",
  "SEO Optimizer",
  "Data Analysis",
  "Business Planning",
];

const dots = ["bg-oriva-cyan", "bg-oriva-gold", "bg-oriva-coral", "bg-oriva-blue"];

export const MarqueeStrip = () => (
  <div className="border-y border-slate-200 bg-slate-50 py-5" data-testid="tools-marquee">
    <Marquee speed={30} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={item} className="mx-7 flex items-center gap-7">
          <span className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
            {item}
          </span>
          <span className={`h-1.5 w-1.5 rounded-full ${dots[i % dots.length]}`} />
        </span>
      ))}
    </Marquee>
  </div>
);
